import { Component } from '@angular/core';

@Component({
    selector: 'app-scroll-to-bottom-btn',
    templateUrl: './scroll-to-bottom-btn.component.html',
    styleUrls: ['./scroll-to-bottom-btn.component.scss'],
    standalone: false
})
export class ScrollToBottomBtnComponent {

  /**
   * @returns {void} Smooth-scrolls the page to the bottom of the document.
   */
  public scrollToPageBottom(): void {
    const scrollElement = document.scrollingElement ?? document.documentElement;
    window.scrollTo({ top: scrollElement.scrollHeight, behavior: 'smooth' });
  }

}
